import React from 'react'

const LogoHippoland = () => (
  <figure>
    <img
      src="https://production.hippoland-contents.com/platform/media/hippo-logo-60c3523fabd22c001161fc95.svg"
      alt="Hippoland | Магазин за играчки"
    />
  </figure>
)

export default LogoHippoland
